import { useCallback, useState } from 'react';
import { bool, func, object } from 'prop-types';
import cx from 'classnames';

import { BACKGROUND, COLOR, TEXT } from 'common/const';
import { getItemFlag, getItemTotals, isZero } from 'common/utils';
import { TextLink, Product, Icon } from 'common/components';

import UpdateQuantity from '../UpdateQuantity';

import styles from './Item.module.css';

const Item = ({
  hasError,
  item,
  reviseOoId,
  isEarlyPricing,
  setRemovingItem,
  updateCart,
}) => {
  // console.log('<Cart.Item>', { item }, item.quantity);

  const [isActive, setIsActive] = useState(false);

  const { currentPrice, originalPrice } = getItemTotals({
    item,
    isEarlyPricing: item?.isEarlyPricing ?? isEarlyPricing,
  });

    //console.log('isEarlyPricing: ', isEarlyPricing);
    //console.log('item.isEarlyPricing: ', item.isEarlyPricing);


  // to keep QuantityButton from firing onChange for every render
  const handleQuantityChange = useCallback(
    (newQuantity, context) => {
      if (newQuantity === item.quantity) {
        return; // ignore if newQuantity is not different
      }

      const totalQuantity = item.totalQuantity;

      const totalItem = { ...item, quantity: totalQuantity };

      const remainder =
        (newQuantity - item.addIncrement) % item.updateIncrement;

      if (isZero(newQuantity)) {
        setRemovingItem(item);
      } else if (newQuantity > item.max) {
        updateCart(totalItem, item.max);
      } else if (newQuantity < item.min) {
        updateCart(totalItem, item.min);
      } else if (newQuantity < item.addIncrement) {
        updateCart(totalItem, item.addIncrement);
      } else if (remainder) {
        updateCart(totalItem, newQuantity - remainder + item.updateIncrement);
      } else {
        updateCart(totalItem, totalQuantity - item.quantity + newQuantity);
      }
    },
    [item, updateCart, setRemovingItem],
  );

  const flag = getItemFlag({ ...item, price: currentPrice });

  return (
    <Product
      variant="cart"
      isActive={isActive}
      id={item.id}
      name={item.name}
      image={item.image}
      currentPrice={currentPrice * item.quantity}
      originalPrice={originalPrice * item.quantity}
      flag={flag}
      quantity={
        <UpdateQuantity
          isActive={isActive && !hasError}
          setIsActive={setIsActive}
          className={cx(BACKGROUND.PAPER, TEXT.SUBTITLE)}
          quantity={item.quantity ?? 0}
          addIncrement={item.addIncrement}
          updateIncrement={item.updateIncrement}
          onChange={handleQuantityChange}
          disabled={
            item.isRequired ||
            hasError ||
            (item.quantity === item.min && item.quantity === item.max)
          }
          min={item.min}
          // You cannot increase the quantity of an item with adv. pricing after deadline date
          max={
            item?.isEarlyPricing &&
            !isEarlyPricing &&
            reviseOoId &&
            item.advancedPrice !== item.floorPrice
              ? item.originalQuantity
              : item.max
          }
        />
      }
    >
      {item.isRequired || item.min > 0 || hasError ? null : (
        <TextLink
          className={styles.remove}
          onClick={() => setRemovingItem(item)}
        >
          <span className={styles.trash}>
            <Icon name="trash" size="small" />
          </span>
          <span className={COLOR.TEXT}>Remove Item</span>
        </TextLink>
      )}
    </Product>
  );
};

Item.propTypes = {
  hasError: bool,
  item: object,
  setRemovingItem: func,
  updateCart: func,
};

export default Item;
